<template>
    <div class="df-attached-file-url">
        <div :class="['d-md-flex', 'align-items-start', { 'flex-column': audit_mode }]">
            <b-button v-b-modal="`attachment-${sub_code}`"
                      :class="['mr-0 mr-md-3 mr-lg-5 f-95', { 'mb-3': audit_mode }]"
                      style="min-width:175px;"
                      :size="audit_mode!=true ? '' : 'sm'"
                      :variant="audit_mode !== true ? 'dark-border':''"
                      :disabled="disabled"
            > {{ $t(`URL / 파일 첨부하기`) }}
                <fa icon="cloud-upload-alt" class="ml-1"></fa>
            </b-button>

            <template v-if="sub_attached_files && sub_attached_files.length">
                <div>
                    <h3 class="pt-1 f-100"> {{ $t(`업로드된 파일/URL`) }} </h3>
                    <div class="w-100 border-top border-bottom border-color-gray-400 border-style-dashed">
                        <b-table-simple class="bor-table border-0 d-block-helper w-100 mb-0 attachments-table-fixed"
                                        style="overflow-x:auto; width:100%;" hover>
                            <b-thead>
                                <b-tr class="bgray-200">
                                    <b-th class="align-middle text-center" style="width:50px;">No.</b-th>
                                    <b-th class="text-break-all col-filename">{{ $t('첨부 파일명 및 URL') }}</b-th>
                                    <b-th v-if="check_custom" class="text-center" style="width: 150px"> {{
                                            $t('첨부 시간')
                                        }}
                                    </b-th>
                                    <b-th class="align-middle text-right" style="width: 50px" v-if="!previous">
                                        {{ $t('삭제') }}
                                    </b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(item, index) in sub_attached_files"
                                      :key="`sub-${sub_code}-attachments-${item.type}-${index}`"
                                      class="bgray-100"
                                >
                                    <b-td class="align-middle text-center" style="width:50px;">
                                        <span class="px-2">{{ index + 1 }}.</span>
                                    </b-td>
                                    <b-td class="align-middle text-break-all col-filename">
                                        <div class="col-filename__inner">
                                            <template v-if="item.type === 'file'">
                                                <b-link :ref="`file_${sub_code}_${index}`"
                                                        class="ellipsis"
                                                        :class="[{'cursor': $route.name !== 'ContractorReport'}, {'text-dark': $route.name === 'ContractorReport'}, 'px-1']"
                                                        @click.prevent="downloadAttachment(item.id, item.filename)"
                                                        :disabled="$route.name === 'ContractorReport'"
                                                >
                                                    <span v-b-tooltip.hover="item.filename">{{ item.filename }}</span>

                                                </b-link>
                                            </template>
                                            <template v-else>
                                                <b-link :href="item.filename" target="_blank"
                                                        class="ellipsis"
                                                        :class="[{'cursor': $route.name !== 'ContractorReport'}, {'text-dark': $route.name === 'ContractorReport'}, 'px-1']"
                                                        :disabled="$route.name === 'ContractorReport'"
                                                >
                                                    <span v-b-tooltip.hover="item.filename">{{ item.filename }}</span>
                                                </b-link>
                                            </template>
                                        </div>
                                    </b-td>
                                    <b-td v-if="check_custom" class="align-middle text-center">
                                        {{ formatDate(item.linked_at) }}
                                    </b-td>
                                    <b-td class="align-middle text-right"
                                          v-if="!previous"
                                    >
                                        <b-btn class="f-90" size="sm" variant="link" @click="unlinkAttachment(item.id)"
                                               v-if="check_unlink_authority"
                                               :disabled="saving_files || is_loading_global_disabled || $route.name === 'ContractorReport'"
                                        >
                                            <BIconXCircle variant="danger"/>
                                        </b-btn>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </div>
            </template>
        </div>

        <b-modal :ref="`attachment-${sub_code}`"
                 :id="`attachment-${sub_code}`"
                 :title="file_modal_title"
                 :no-close-on-esc="saving_files"
                 :no-close-on-backdrop="saving_files"
                 hide-header-close
                 size="xl"
                 footer-class="py-2"
                 centered
                 @hidden="initializeAttachments"
        >
            <b-container fluid>
                <template v-if="saving_files">
                    <b-row>
                        <b-col>
                            <div class="d-flex align-items-center justify-content-center f-120 py-5">
                                <span class="mr-3"> {{ $t(`파일을 업로드 중입니다. 잠시만 기다려 주세요...`) }} </span>
                                <b-spinner style="height: 1.5rem;width: 1.5rem;"></b-spinner>
                            </div>
                        </b-col>
                    </b-row>
                </template>

                <template v-else>
                    <b-row class="mb-3">
                        <b-col cols="12">
                            <b-card :header="$t('파일 업로드')" header-class="h5">
                                <b-row>
                                    <b-col cols="12" lg="6">
                                        <div class="mb-2">
                                            <fa icon="paperclip" class="f-100 mr-2"></fa>
                                            <span class="f-110">File</span>
                                        </div>
                                        <b-form-file
                                            v-model="attachment_files"
                                            @input="inputFile"
                                            :placeholder="form_placeholder"
                                            :disabled="saving_files || is_loading_global_disabled"
                                            class="text-left"
                                            multiple
                                        >
                                        </b-form-file>
                                    </b-col>
                                    <b-col cols="12" lg="6">
                                        <div class="mb-2">
                                            <fa icon="link" class="f-100 mr-2"></fa>
                                            <span class="f-110">URL</span>
                                        </div>
                                        <b-input-group>
                                            <b-form-input v-model="attachment_url"
                                                          placeholder="https://"
                                                          @keypress.enter="addURLtoUploadList"
                                                          :disabled="saving_files || is_loading_global_disabled"
                                            />
                                            <b-input-group-append>
                                                <b-button variant="light" class="border"
                                                          @click="addURLtoUploadList"
                                                          :disabled="!attachment_url || saving_files || is_loading_global_disabled"
                                                >
                                                    <BIconPlus/>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <template v-if="uploading_list.length">
                                    <b-row class="my-3">
                                        <b-col cols="12">
                                            <hr>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="">
                                            <b-card no-body>
                                                <template #header>
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div class="h6 mb-0">{{ $t('첨부할 파일 및 URL 확인') }}</div>

                                                        <b-btn variant="primary"
                                                               size="sm"
                                                               @click="uploadAttachmentFile"
                                                               :disabled="!uploading_list.length || saving_files || is_loading_global_disabled"
                                                        >
                                                            <fa icon="save"></fa>
                                                            {{ $t('저장하기') }}
                                                        </b-btn>
                                                    </div>
                                                </template>
                                                <b-table-simple class="mb-0" hover>
                                                    <b-thead>
                                                        <b-tr>
                                                            <b-th>No.</b-th>
                                                            <b-th>{{ $t('유형') }}</b-th>
                                                            <b-th>{{ $t('첨부 파일명 및 URL') }}</b-th>
                                                            <b-th>{{ $t('삭제') }}</b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <b-tr v-for="(upload_item, upload_idx) in uploading_list"
                                                              :key="`subs-${sub_code}-attachment-uploads-${upload_idx}-type-${upload_item.type}`"
                                                        >
                                                            <b-td>
                                                                {{ upload_idx + 1 }}
                                                            </b-td>
                                                            <b-td>
                                                                <b-badge>{{
                                                                        upload_item.type.toLocaleUpperCase()
                                                                    }}
                                                                </b-badge>
                                                            </b-td>
                                                            <b-td class="text-break-all">
                                                                {{ upload_item.name }}
                                                            </b-td>
                                                            <b-td>
                                                                <template v-if="upload_item.type === 'file'">
                                                                    <b-btn variant="danger" size="sm"
                                                                           :disabled="saving_files || is_loading_global_disabled"
                                                                           @click="deleteFiletoUploadList(upload_item)"
                                                                    >
                                                                        {{ $t('삭제하기') }}
                                                                    </b-btn>
                                                                </template>
                                                                <template v-else>
                                                                    <b-btn variant="danger" size="sm"
                                                                           :disabled="saving_files || is_loading_global_disabled"
                                                                           @click="deleteURLtoUploadList(upload_item)"
                                                                    >
                                                                        {{ $t('삭제하기') }}
                                                                    </b-btn>
                                                                </template>
                                                            </b-td>
                                                        </b-tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-card>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12">
                            <b-card :header="$t('첨부파일 목록')" header-class="h5" no-body>
                                <div class="d-flex align-items-center justify-content-center my-3 mx-3" style="gap: 12px">
                                    <b-input v-model="fileNameSearch" :placeholder="$t('첨부파일명을 입력해주세요')"
                                             @keypress.enter="searchAttachments"
                                    ></b-input>
                                    <b-button @click="searchAttachments" variant="primary">{{$t('검색')}}</b-button>
                                    <b-button @click="resetSearch" variant="secondary">{{$t('초기화')}}</b-button>
                                </div>
                                
                                <b-table :items="filteredAttachments" :fields="attachments_field"
                                         :empty-text="$t('업로드된 파일이 없습니다.')"
                                         :busy="saving_files || is_loading_attachments_list || is_loading_link_attachment"
                                         show-empty
                                         class="mb-0"
                                >
                                    <template #empty="scope">
                                        <div class="text-center">
                                            <h6 class="gray-500 mb-0">{{ scope.emptyText }}</h6>
                                        </div>
                                    </template>

                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <strong class="mr-2">{{ $t('처리중입니다. 잠시만 기다려주세요...') }}</strong>
                                            <b-spinner class="align-middle"
                                                       style="width: 1.3rem;height: 1.3rem;"></b-spinner>
                                        </div>
                                    </template>


                                    <template #cell(index)="data">
                                        <div class="text-center">
                                            {{ data.index + 1 }}.
                                        </div>
                                    </template>

                                    <template #cell(attachment_type)="data">
                                        <b-badge>{{ data.value.toLocaleUpperCase() }}</b-badge>
                                    </template>


                                    <template #cell(filename)="data">
                                        <div
                                            :class="[{ 'd-flex align-items-center': sub_attached_files_id.length && sub_attached_files_id.includes(data.item.id) }]">
                                            <template
                                                v-if="sub_attached_files_id.length && sub_attached_files_id.includes(data.item.id)">
                                                <b-badge variant="success" class="f-70">
                                                    {{ (label ?? sub_code) + ' ' + $t('문항 첨부') }}
                                                </b-badge>
                                            </template>
                                            <span
                                                :class="[{ 'ml-2': sub_attached_files_id.length && sub_attached_files_id.includes(data.item.id) }]">{{
                                                    data.value
                                                }}</span>
                                        </div>
                                    </template>

                                    <template #cell(user)="data">
                                        {{ data.value ? data.value.user_name : ' - ' }}
                                    </template>

                                    <template #cell(created_at)="data">
                                        {{ formatDate(data.value) }}
                                    </template>

                                    <template #cell(action)="data">
                                        <template
                                            v-if="sub_attached_files_id.length && sub_attached_files_id.includes(data.item.id)">
                                            <b-btn size="sm" variant="danger" @click="unlinkAttachment(data.item.id)"
                                                   :disabled="saving_files || is_loading_global_disabled"
                                            >
                                                {{ $t('취소') }}
                                            </b-btn>
                                        </template>
                                        <template v-else>
                                            <b-btn size="sm" variant="primary" @click="linkAttachment(data.item.id)"
                                                   :disabled="saving_files || is_loading_global_disabled"
                                            >
                                                {{ $t('첨부하기') }}
                                            </b-btn>
                                        </template>
                                    </template>
                                </b-table>
                            </b-card>
                        </b-col>
                    </b-row>
                </template>
            </b-container>

            <template #modal-footer>
                <div class="d-flex align-items-center justify-content-end px-3">
                    <b-button variant="danger"
                              @click="handleOK(`attachment-${sub_code}`)"
                              :disabled="is_loading_global_disabled"
                    >
                        {{ $t(`닫기`) }}
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import * as SentryBrowser from "@sentry/browser";
import downloadFile from '@core_mixins/downloadFile';
import {BIconPlus} from 'bootstrap-vue';
import {isValidURL} from "@core/utils/subComponent/check-attachment";

export default {
    name: "df-attached-file-url",
    props: {
        has_attachment: {
            type: Boolean,
            required: false,
            default: false
        },
        sub_id: {
            required: true,
            validator: (prop) => typeof prop === 'number' || prop === null
        },
        label: {
            type: String,
            default: null
        },
        sub_code: {
            required: true,
            type: String
        },
        sub_init_id: {
            required: true,
            type: Number
        },
        company_id: {
            required: true,
            validator: (prop) => typeof prop === 'number' || prop === null
        },
        company_name: {
            required: true,
            validator: (prop) => typeof prop === 'string' || prop === null
        },
        campaign_id: {
            required: true,
            validator: (prop) => typeof prop === 'number' || prop === null
        },
        disabled: {
            type: Boolean
        },
        audit_mode: {
            type: Boolean
        },
        previous: {
            type: Boolean
        }
    },
    components: {
        BIconPlus
    },
    mixins: [
        downloadFile
    ],
    data() {
        return {
            saving_files: false,
            attachment_files: [],
            attachment_url: 'https://',
            uploading_file: [],
            uploading_urls: [],
            fileNameSearch: '',
            filteredAttachments: [],
            isSearchActive: false
        }
    },
    computed: {
        ...mapState({
            is_admin: "is_admin",
            user_company_id: 'company_id',
            map_campaigns: 'map_campaigns'
        }),
        ...mapState(['view_mode', 'campaign_in_progress', 'campaign', 'admin_mode']),
        ...mapState('questions', ['answer_company']),
        ...mapState('attachments', ['is_loading_attachments_list', 'is_loading_add_attachment', 'is_loading_link_attachment']),
        ...mapGetters('attachments', ['is_loading_global_disabled', 'get_prev_attachments']),
        check_custom() {
            return process.env.VUE_APP_CUSTOM_ENV != null && this.$route.path.includes('/answers')
        },
        attachments_field() {
            return [
                {
                    key: 'index',
                    label: 'No.',
                    thStyle: {
                        'width': '5%'
                    },
                    tdClass: ['f-95']
                },
                {
                    key: 'attachment_type',
                    label: this.$t('첨부 유형'),
                    thStyle: {
                        'width': this.$i18n.locale === 'ko' ? '10%' : '15%'
                    },
                    tdClass: ['f-90']
                },
                {
                    key: 'filename',
                    label: this.$t('파일 이름'),
                    thStyle: {},
                    tdClass: ['f-90 text-break-all']
                },
                {
                    key: 'user',
                    label: this.$t('업로드 사용자'),
                    thStyle: {
                        'width': '10.5%',
                        'text-align': 'center'
                    },
                    tdClass: ['f-90', 'text-center']
                },
                {
                    key: 'action',
                    label: this.$t('첨부 및 취소'),
                    thStyle: {
                        'width': '18%',
                        'text-align': 'center'
                    },
                    tdClass: ['f-90', 'text-center']
                }
            ]
        },
        file_modal_title() {
            return this.$t(`URL / 파일 첨부하기`)
        },
        form_placeholder() {
            return this.$t(`여기로 끌어오거나, 클릭하여 파일을 찾으세요.`)
        },
        target_company_id() {
            if (this.previous) {
                return this.company_id
            }
            if (this.$route.query.cpn) {
                return this.$route.query.cpn
            }

            if (this.$route.query.company_id) {
                return this.$route.query.company_id
            }

            return this.view_mode === 'user'
                ? this.company_id
                : this.answer_company.company_id
        },
        target_campaign_id() {
            if (this.previous) {
                return this.campaign_id
            }
            if (this.$route.query.cmp) {
                return this.$route.query.cmp
            }

            if (this.$route.query.campaign_id) {
                return this.$route.params.campaign_id
            }

            if (this.view_mode === 'provider') {
                if (this.previous) {
                    return this.$store.campaign.previous_campaign_id
                } else {
                    return this.$store.questions.answer_company.campaign_id
                }
            } else {
                return this.campaign_in_progress.previous_campaign_id
            }
        },
        uploading_list() {
            const _uploading_list = []
            if (this.uploading_file.length) {
                this.uploading_file.forEach(file => {
                    _uploading_list.push({type: 'file', name: file.name, file})
                });
            }

            if (this.uploading_urls.length) {
                this.uploading_urls.forEach(url => {
                    _uploading_list.push({type: 'url', name: url, url})
                });
            }

            return _uploading_list
        },
        get_attatchments() {
            if (!this.has_attachment || !this.$store.getters['attachments/get_attatchments'].length) {
                return []
            } else {
                return [...this.$store.getters['attachments/get_attatchments']].sort((a, b) => {
                    if (!a.sub_list && !b.sub_list) {
                        return new Date(b.created_at) - new Date(a.created_at)
                    } else {
                        const _a_inlcuded_sub = a.sub_list.some(({id}) => id === this.sub_id) ? 1 : 0
                        const _b_inlcuded_sub = b.sub_list.some(({id}) => id === this.sub_id) ? 1 : 0

                        if (_a_inlcuded_sub !== _b_inlcuded_sub) {
                            return _b_inlcuded_sub - _a_inlcuded_sub
                        } else {
                            return b.id - a.id
                        }
                    }
                })
            }
        },
        sub_attached_files() {
            if (!this.has_attachment) {
                return []
            }
            if (this.previous) {
                return this.get_prev_attachments(this.campaign_id, this.company_id, this.sub_code)
            }

            return this.get_attatchments.reduce((_sub_attached, _attached) => {
                let linked_at = null
                const _is_attached_to_sub = _attached.sub_list.find(({id}) => id === this.sub_id)
                if (_is_attached_to_sub) {
                    linked_at = _is_attached_to_sub.linked_at
                    const {id, attachment_type, filename} = _attached
                    if (attachment_type === "file") {
                        _sub_attached.push({id, type: attachment_type, filename, file_link: null, linked_at})
                    } else {
                        _sub_attached.push({id, type: attachment_type, filename, file_link: filename, linked_at})
                    }

                }
                return _sub_attached
            }, [])
        },
        sub_attached_files_id() {
            if (!this.sub_id || !this.get_attatchments || !this.get_attatchments.length || !this.has_attachment) {
                return []
            }

            if (this.previous) {
                return this.get_prev_attachments(this.campaign_id, this.company_id, this.sub_code).map(({id}) => id)
            }

            return this.get_attatchments.reduce((_sub_attached, _attached) => {
                const _is_attached_to_sub = _attached.sub_list.find(({id}) => id === this.sub_id)
                if (_is_attached_to_sub) {
                    _sub_attached.push(_attached.id)
                }
                return _sub_attached
            }, [])
        },
        check_unlink_authority() {
            return [3, 4].includes(this.is_admin) || this.target_company_id === this.user_company_id || (this.map_campaigns[this.target_campaign_id] && this.map_campaigns[this.target_campaign_id] != null)
        }
    },
    watch: {
        get_attatchments: {
            handler(newVal) {
                if (!this.isSearchActive) {
                    this.filteredAttachments = [...newVal];
                }
            },
            immediate: true,
            deep: true
        }
    },
    async created() {
        if (!this.previous || !this.has_attachment) return

        await this.getPrevSubsAttachments({
            campaign_id: this.campaign_id,
            company_id: this.company_id,
            sub_code: this.sub_code,
        })
    },
    mounted() {
        this.$root.$on('bv::tooltip::show', this.onTooltipShow);
    },
    beforeDestroy() {
        this.saving_files = false
        this.attachment_files = []
        this.attachment_url = 'https://'
        this.uploading_file = []
        this.uploading_urls = []
        this.$root.$off('bv::tooltip::show', this.onTooltipShow);
    },
    methods: {
        ...mapActions('attachments', ['getAttatchments', 'uploadAttachments', 'linkAttachments', 'unlinkAttachments', 'deleteAttachments', 'getPrevSubsAttachments']),
        async linkAttachment(storage_id) {
            try {
                this.saving_files = true

                if (!this.sub_id) {
                    const response = await this.$axios.post('/subs', {
                        sub_id: this.sub_id,
                        sub_init_id: this.sub_init_id,
                        company_id: this.target_company_id,
                        company_name: this.$route.query.cpnm,
                        campaign_id: this.target_campaign_id,
                        // question_code: this.$route.params.question_code,
                        question_code: this.question_code,
                        sub_code: this.sub_code,
                        sub_data_contents: this.sub_data_contents,
                        score_result: this.score_result
                    })

                    this.$store.commit('questions/update_sub', response.data)
                }

                await this.linkAttachments({
                    company_id: this.target_company_id,
                    campaign_id: this.target_campaign_id,
                    sub_id: this.sub_id,
                    sub_code: this.sub_code,
                    storage_id: [storage_id]
                })


                this.uploading_file = []
                this.uploading_urls = []
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.target_company_id);
                    scope.setTag('campaign_id', this.target_campaign_id);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'link');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                alert(this.$t("죄송합니다. 첨부하는 도중 장애가 발생했습니다. 다시 시도해주세요."))
                await this.getAttatchments({company_id: this.target_company_id, campaign_id: this.target_campaign_id})
            } finally {
                this.saving_files = false
            }
        },
        async unlinkAttachment(attchmt_id) {
            try {
                this.saving_files = true
                await this.unlinkAttachments({
                    campaign_id: this.target_campaign_id,
                    company_id: this.target_company_id,
                    sub_id: this.sub_id,
                    sub_code: this.sub_code,
                    storage_id: [attchmt_id],
                })
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.target_company_id);
                    scope.setTag('campaign_id', this.target_campaign_id);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'unlink');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                alert(this.$t("죄송합니다. 첨부 해제 중 발생했습니다. 다시 시도해주세요."))
                await this.getAttatchments({company_id: this.target_company_id, campaign_id: this.target_campaign_id})
            } finally {
                this.saving_files = false
            }
        },
        async uploadAttachmentFile() {
            try {
                this.saving_files = true
                if (this.uploading_list.length) {
                    const _res_uploaded = await this.uploadAttachments({
                        company_id: this.target_company_id,
                        campaign_id: this.target_campaign_id,
                        uploadAttchmts: this.uploading_list
                    })

                    const _uploaded_storage_id = _res_uploaded.map(({id}) => id)
                    if (!this.sub_id) {
                        const response = await this.$axios.post('/subs', {
                            sub_id: this.sub_id,
                            sub_init_id: this.sub_init_id,
                            company_id: this.target_company_id,
                            company_name: this.$route.query.cpnm,
                            campaign_id: this.target_campaign_id,
                            question_code: this.question_code,
                            sub_code: this.sub_code,
                            sub_data_contents: this.sub_data_contents,
                            score_result: this.score_result
                        })

                        this.$store.commit('questions/update_sub', response.data)
                    }

                    await this.linkAttachments({
                        company_id: this.target_company_id,
                        campaign_id: this.target_campaign_id,
                        sub_id: this.sub_id,
                        sub_code: this.sub_code,
                        storage_id: _uploaded_storage_id
                    })
                }

                this.uploading_file = []
                this.uploading_urls = []
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.target_company_id);
                    scope.setTag('campaign_id', this.target_campaign_id);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'upload');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                alert(this.$t("죄송합니다. 파일 업로드 및 문항 첨부 중 장애가 발생했습니다. 다시 시도해주세요."))
                this.attachment_files = []
                this.attachment_url = 'https://'
                this.uploading_file = []
                this.uploading_urls = []

                await this.getAttatchments({company_id: this.target_company_id, campaign_id: this.target_campaign_id})
            } finally {
                this.saving_files = false
            }
        },
        inputFile() {
            if (process.env.VUE_APP_CUSTOM_ENV)
                this.customAddFileToUploadList();
            else
                this.addFiletoUploadList();
        },
        addFiletoUploadList() {
            const _sized_0_filtered_files = this.attachment_files.filter(({size}) => size === 0)
            const _sized_filtered_files = this.attachment_files.filter(({size}) => size > 0)

            if (_sized_0_filtered_files.length > 0) {
                if (_sized_0_filtered_files.length === this.attachment_files.length) {
                    alert('업로드 대상 파일이 모두 빈 파일 입니다. 확인 후 업로드 해주시기 바랍니다.')
                    return false
                } else {
                    alert('업로드 파일 중 빈 파일이 발견되어 제외하고 업로드 목록에 추가되었습니다.')
                }
            }


            if (this.uploading_file.length) {
                _sized_filtered_files.map(_file => {
                    const _is_duplicated_file = this.uploading_file.find(({
                                                                              name,
                                                                              size
                                                                          }) => name === _file.name && size === _file.size)
                    if (!_is_duplicated_file) {
                        this.uploading_file.push(_file)
                    }
                })
            } else {
                _sized_filtered_files.map(_file => {
                    this.uploading_file.push(_file)
                })
            }

            if (_sized_0_filtered_files.length) {
                this.attachment_files = _sized_0_filtered_files
            } else {
                this.attachment_files = []
            }
        },
        customAddFileToUploadList() {
            const _failed_file_list = [];
            const _uploading_files = [];

            const allowedExtensions = new Set([
                "txt", "md", "json", "xml", "csv",
                "pdf", "docx",
                "xlsx",
                "pptx",
                "png", "jpg", "jpeg", "gif"
            ]);
            const maxSizeMB = 30;
            const maxFilesCount = 20;

            if (this.attachment_files.length > maxFilesCount) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('최대 업로드 파일 개수 초과'),
                    message: this.$t(`한 번에 업로드할 수 있는 파일은 최대 20개 입니다.`)
                });

                return
            }

            this.attachment_files.map(_file => {
                const ext = _file.name.split('.').pop().toLowerCase();
                if (!_file.name.includes('.')) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('파일 확장자가 없습니다.')
                    });
                } else if (!allowedExtensions.has(ext)) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('허용하지 않는 파일 형식입니다.')
                    });
                } else if (_file.size === 0) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('빈 파일입니다.')
                    });
                } else if (_file.size > 1024 * 1024 * maxSizeMB) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('파일 크기가 30MB를 초과합니다.')
                    });
                } else if (this.uploading_file.find(({name, size}) => name === _file.name && size === _file.size)) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('이미 업로드 목록에 존재하는 파일입니다.')
                    });
                } else {
                    _uploading_files.push(_file);
                }
            });

            if (_failed_file_list.length > 0) {
                const h = this.$createElement;

                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('조건에 맞지 않는 파일은 제외되었습니다.'),
                    message: h('div', [
                        h('ul', _failed_file_list.map(file => h('li', `${file.name} : ${file.reason}`)))
                    ])
                });
            }
            this.uploading_file = this.uploading_file.concat(_uploading_files);

            this.attachment_files = [];
        },
        deleteFiletoUploadList(_file) {
            if (this.uploading_file.length) {
                const _delete_file_idx = this.uploading_file.findIndex(file => file.name === _file.name)
                if (_delete_file_idx > -1) {
                    this.uploading_file.splice(_delete_file_idx, 1)
                }
            }
        },
        addURLtoUploadList() {
            if (!this.attachment_url) {
                return false
            }

            const _is_included_url = this.uploading_urls.find((url) => url === this.attachment_url)
            if (_is_included_url) {
                alert(this.$t('이미 첨부된 주소 입니다.'))
                return false;
            }

            if (!this.isValidURL(this.attachment_url)) {
                alert(this.$t('올바른 URL 형식으로 입력해 주십시오 (http/https)'))
                return false;
            }

            this.uploading_urls.push(this.attachment_url)
        },
        deleteURLtoUploadList(_url) {
            if (this.uploading_urls.length) {
                const _delete_url_idx = this.uploading_urls.findIndex(url => url === _url.url)
                if (_delete_url_idx > -1) {
                    this.uploading_urls.splice(_delete_url_idx, 1)
                }
            }
        },
        async downloadAttachment(storage_id, filename) {
            try {
                const campaign_id = this.previous ? undefined : this.target_campaign_id;

                const _res_downdload_attachment = await this.$axios.get('/attachment/download', {
                    params: {
                        campaign_id,
                        company_id: this.target_company_id,
                        storage_id: [storage_id]
                    },
                    responseType: 'blob'
                })

                this.downloadFileFromResponse(_res_downdload_attachment, filename)
            } catch (error) {
                SentryBrowser.getCurrentScope().setTransactionName("AttachedFileError");
                SentryBrowser.withScope((scope) => {
                    scope.setTag('company_id', this.target_company_id);
                    scope.setTag('campaign_id', this.target_campaign_id);
                    scope.setTag('question_code', this.question_code);
                    scope.setTag('sub_id', this.sub_id);
                    scope.setTag('sub_code', this.sub_code);
                    scope.setTag('attached_type', 'download');
                    scope.setLevel("warning");
                    SentryBrowser.captureException(error);
                });

                alert(this.$t("파일 다운로드에 실패하였습니다. 다시 시도해 주세요."))
            }
        },
        isValidURL(str) {
            return isValidURL(str)
        },
        initializeAttachments() {
            if (this.saving_files) {
                this.saving_files = false
            }
            this.attachment_files = []
            this.attachment_url = 'https://'
            this.uploading_file = []
            this.uploading_urls = []
        },
        searchAttachments() {
            const searchTerm = this.fileNameSearch.trim().toLowerCase();
            
            if (!searchTerm) {
                this.resetSearch();
                return;
            }
            
            this.isSearchActive = true;
            this.filteredAttachments = this.get_attatchments.filter(item => {
                return item.filename.toLowerCase().includes(searchTerm);
            });
        },
        resetSearch() {
            this.fileNameSearch = '';
            this.isSearchActive = false;
            this.filteredAttachments = [...this.get_attatchments];
        },
        handleOK(ref) {
            this.$refs[ref].hide()
            this.saving_files = false
        },
        onTooltipShow(bvEvent) {
            const targetEl = bvEvent.target;

            const tooltip = bvEvent.vueTarget;
            if (!tooltip) return;

            const width = targetEl.offsetWidth;
            tooltip.offset = -(width / 2);
        }
    }
}
</script>

<style>
@media (max-width: 540px) {
    .d-block-helper {
        display: block;
    }
}

.anchor-disabled {
    pointer-events: none;
    color: var(--gray-600)
}

/* attachments filename column ellipsis */
.attachments-table-fixed {
    table-layout: fixed;
}

.attachments-table-fixed th.col-filename {
    width: calc(100% - 250px);
    max-width: calc(100% - 250px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.attachments-table-fixed td.col-filename .col-filename__inner {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
